enum GtmInfoBtnId {
    SB = 'SB',
    VS = 'VS',
    ZAHLUNGSWEISE = 'ZAHLUNGSWEISE',
    PRODUKT = 'PRODUKT',
    VERTRAGSLAUFZEIT = 'VERTRAGSLAUFZEIT',
    HUNDE_RASSE = 'HUNDE_RASSE',
    HUND_VERSICHERBAR = 'HUND_VERSICHERBAR',
    PRODUKT_DECKUNG_BETREUUNG = 'PRODUKT_DECKUNG_BETREUUNG',
    PRODUKT_DECKUNG_DIGIT_TIERARZT = 'PRODUKT_DECKUNG_DIGIT_TIERARZT',
    PRODUKT_DECKUNG_NOTFALLTRANSPORT = 'PRODUKT_DECKUNG_NOTFALLTRANSPORT',
    PRODUKT_DECKUNG_VERMITTLUNG_TIERARZT = 'PRODUKT_DECKUNG_VERMITTLUNG_TIERARZT',
    PRODUKT_DECKUNG_BERATUNG_VERMITTLUNG = 'PRODUKT_DECKUNG_BERATUNG_VERMITTLUNG',
    PRODUKT_DECKUNG_BERATUNG_IMPFUNG = 'PRODUKT_DECKUNG_BERATUNG_IMPFUNG',
    PRODUKT_DECKUNG_HOTLINE = 'PRODUKT_DECKUNG_HOTLINE',
    PRODUKT_DECKUNG_OHNE_WARTEZEIT = 'PRODUKT_DECKUNG_OHNE_WARTEZEIT',
    PRODUKT_DECKUNG_TIERARZTKOSTEN = 'PRODUKT_DECKUNG_TIERARZTKOSTEN',
    PRODUKT_DECKUNG_OHNE_LEINE = 'PRODUKT_DECKUNG_OHNE_LEINE',
    PRODUKT_DECKUNG_BERGUNGSKOSTEN = 'PRODUKT_DECKUNG_BERGUNGSKOSTEN',
    PRODUKT_DECKUNG_ANSPRUECHE = 'PRODUKT_DECKUNG_ANSPRUECHE',
    PRODUKT_DECKUNG_SCHAEDEN_GEMIETETE_RAEUME = 'PRODUKT_DECKUNG_SCHAEDEN_GEMIETETE_RAEUME',
    PRODUKT_DECKUNG_SCHAEDEN_SONSTIGE = 'PRODUKT_DECKUNG_SCHAEDEN_SONSTIGE',
    PRODUKT_DECKUNG_WELPEN = 'PRODUKT_DECKUNG_WELPEN',
    PRODUKT_DECKUNG_AUSLAND = 'PRODUKT_DECKUNG_AUSLAND'
}

export default GtmInfoBtnId;